export const fmtMoney = (v: any, currency = 'USD') => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(v || 0));
export const fmtDate = (v: any) => {
    if (!v) return '';
    if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
        const [year, month, day] = v.split('-').map(Number);
        return new Date(year, month - 1, day).toLocaleDateString();
    }
    return new Date(v).toLocaleDateString();
};
